import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const KidneyStonesPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Kidney Stones</h1>
        <section className="mb-8">
          <p>Kidney stones are hard deposits that form in the kidneys and can cause severe pain and discomfort. Our natural therapies focus on dissolving stones, preventing their formation, and improving kidney function through gentle, non-invasive methods.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Dehydration</li>
            <li>High mineral content in urine</li>
            <li>Poor diet</li>
            <li>Family history</li>
            <li>Certain medical conditions</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Severe pain in back or side</li>
            <li>Painful urination</li>
            <li>Blood in urine</li>
            <li>Nausea and vomiting</li>
            <li>Frequent urination</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use stone-dissolving herbs, dietary modifications, and lifestyle changes to naturally treat kidney stones. Our approach focuses on improving kidney function, preventing stone formation, and promoting urinary health through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Non-surgical treatment</li>
            <li>Dissolves stones naturally</li>
            <li>Improves kidney function</li>
            <li>Prevents recurrence</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Stay well hydrated</li>
            <li>Follow a balanced diet</li>
            <li>Limit salt intake</li>
            <li>Regular exercise</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment dissolve kidney stones?</strong>
            <p>A: Yes, our natural approach can help dissolve stones and improve kidney function.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment painful?</strong>
            <p>A: Our treatments are gentle and focus on reducing pain while promoting healing.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How long does treatment take?</strong>
            <p>A: Treatment duration varies, but many patients see improvement within a few weeks.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from kidney stones—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default KidneyStonesPage; 